import { defineRouting } from "next-intl/routing"

export const routing = defineRouting({
  locales: ["km", "en"],
  defaultLocale: "km",
  localePrefix: "as-needed",
  // The dashboard already uses a cookie named NEXT_LOCALE (lib/locale.ts) for
  // its own unrelated cookie-based locale switching. next-intl defaults to
  // reading/writing a cookie of that exact same name, which collides with
  // it — disable next-intl's cookie so site locale comes from the URL only.
  localeCookie: false,
  // Also disable Accept-Language sniffing: bare "/" must always render Khmer
  // regardless of the visitor's browser language, so existing bookmarks/SEO
  // for "/" never silently redirect to "/en".
  localeDetection: false,
})
